import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ChatCircleText, PaperPlaneRight, SpinnerGap, ArrowBendDownRight } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg, fmtDate } from "@/lib/api";

function Thread({ m }) {
  return (
    <article className="rounded-2xl border border-border bg-white p-5" data-testid={`host-message-${m.message_id}`}>
      <p className="text-xs text-muted-foreground">You · {fmtDate(m.created_at)}{m.source === "welcome" ? " · Reply to welcome note" : ""}</p>
      <p className="mt-1 whitespace-pre-wrap text-sm">{m.body}</p>
      {m.replies.map((r, i) => (
        <div key={i} className="mt-3 flex gap-2 rounded-xl bg-[#F5F7FA] p-3" data-testid={`host-message-reply-${m.message_id}-${i}`}>
          <ArrowBendDownRight className="mt-0.5 shrink-0 text-[#0E1729]" />
          <div><p className="text-xs text-muted-foreground"><b className="text-[#0E1729]">{r.by}</b> · Hostkey · {fmtDate(r.at)}</p><p className="mt-1 whitespace-pre-wrap text-sm">{r.body}</p></div>
        </div>
      ))}
      {!m.replies.length && <p className="mt-3 text-xs text-muted-foreground">We'll reply by email and here.</p>}
    </article>
  );
}

export default function Messages() {
  const [params] = useSearchParams();
  const welcome = params.get("from") === "welcome";
  const [items, setItems] = useState(null);
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/messages").then((r) => setItems(r.data)); }, []);
  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/messages", { body, source: welcome ? "welcome" : "dashboard" });
      setItems((x) => [r.data, ...(x || [])]); setBody(""); toast.success("Message sent. We'll get back to you soon.");
    } catch (e2) { toast.error(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <div className="max-w-3xl" data-testid="host-messages-page">
      <h1 className="font-display text-3xl font-medium tracking-tight sm:text-4xl">{welcome ? "Reply to Ibrahim" : "Message Hostkey"}</h1>
      <p className="mt-2 text-muted-foreground">{welcome ? "Tell Ibrahim about your Airbnb, or ask anything. He reads every message." : "Questions, ideas or problems: write to the Hostkey team. We reply by email."}</p>
      <form onSubmit={send} className="mt-6 rounded-2xl border border-border bg-white p-5" data-testid="host-message-form">
        <Textarea rows={5} required minLength={2} maxLength={3000} value={body} onChange={(e) => setBody(e.target.value)} placeholder="Write your message…" data-testid="host-message-input" />
        <div className="mt-3 flex items-center justify-between">
          <span className="text-xs text-muted-foreground">{body.length}/3000</span>
          <button disabled={busy || body.trim().length < 2} data-testid="host-message-send-button" className="inline-flex h-10 items-center gap-2 rounded-full bg-[#0E1729] px-5 text-sm font-semibold text-white disabled:opacity-50">
            {busy ? <SpinnerGap className="animate-spin" /> : <PaperPlaneRight />} Send
          </button>
        </div>
      </form>
      <h2 className="mt-10 flex items-center gap-2 font-display text-lg"><ChatCircleText /> Your messages</h2>
      <div className="mt-3 space-y-3" data-testid="host-messages-list">
        {items?.length === 0 && <p className="text-sm text-muted-foreground" data-testid="host-messages-empty">No messages yet.</p>}
        {items?.map((m) => <Thread key={m.message_id} m={m} />)}
      </div>
    </div>
  );
}
